module.exports = __webpack_public_path__ + "static/img/wuxi3.57d4747.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/homePortal/wuxi3.jpg
// module id = HcVP
// module chunks = 1